import { EMAIL_REGEX } from '../../constant/constants'

export default (value) => {
  return value && EMAIL_REGEX.test(String(value).toLowerCase())
}
